import * as d3 from 'd3'
export default {
  methods: {

    draw_Structure(blk, disc, gy, idx) {
      
      let box = {width: 160, height: 100, }

      let img = this.canvasStatus
      .append('g')
      .attr('transform', `translate(${disc.sx+10}, ${gy})`)
      .call(this.call_Block, disc, blk)

      img
      .append('rect')
      .attr('x', 0).attr('y', 0).attr('rx', 3)
      .attr('width', box.width).attr('height', box.height)
      .attr('fill', '#fff').attr('stroke', blk.A_SD ? '#83D2F5' : '#E0E0DF')
      .attr('stroke-width', blk.A_SD ? 1 : .5)

      img
      .append('image')
      .attr('xlink:href', this.HOST + `/Monthly_Report/Erection/${blk.ER_BK}.jpg`)
      .attr('x', 10).attr('y', 6.5).attr('width', 140)
      // .attr('opacity', blk.A_SD ? 1 : .4)

      let canvasItem = this.canvasStatus
      .append('g')
      .attr('transform', `translate(${disc.sx+10}, ${gy})`)

      canvasItem
      .append('text')
      .attr('id', `BLK_${idx}`)
      .attr('x', 0).attr('y', -3)
      .attr('font-size', 12).attr('fill', '#000')
      .text(blk.ER_BK)

      canvasItem
      .append('text')
      .attr('x', this.getNode(`#BLK_${idx}`)+3).attr('y', -3)
      .attr('font-size', 10).attr('fill', '#757575')
      .text(blk.MOD)

      canvasItem
      .append('text')
      .attr('x', box.width + 10).attr('y', 10).attr('font-size', 10).attr('fill', '#828282')
      .text('Plan')

      canvasItem
      .append('text')
      .attr('x', box.width + 10).attr('y', 23).attr('font-size', 13).attr('fill', '#757575')
      .text(blk.P_SD)

      canvasItem
      .append('text')
      .attr('x', box.width + 10).attr('y', 40).attr('font-size', 10).attr('fill', '#828282')
      .text('Actual')

      canvasItem
      .append('text')
      .attr('x', box.width + 10).attr('y', 53).attr('font-size', 13).attr('fill', '#000')
      .text(blk.A_SD)

      canvasItem
      .append('text')
      .attr('x', box.width + 10).attr('y', 75).attr('font-size', 10).attr('fill', '#757575')
      .text('Delta')

      // Delta Value
      if(blk.A_SD) {
        let delta = this.gmx_dateDiff(blk.P_SD, blk.A_SD)
        canvasItem
        .append('text')
        .attr('x', box.width + 10).attr('y', 93).attr('font-size', 13).attr('fill', this.gmx_deltaValue(delta))
        .text(delta + 'days')
      }
    },



    draw_Outfitting(blk, disc, gy) {

      let canvasItem = this.canvasStatus
      .append('g')
      .attr('transform', `translate(${disc.sx+20}, ${gy+12})`)

      let count = 0
      this.items[disc.code].forEach(d=> {
        if(blk[`${d.code}_TOT`] > 0) count ++
      })
      if(count==0) return 

      canvasItem // Total
      .append('text')
      .attr('x', 97).attr('y', -13)
      .attr('font-size', 9).attr('fill', '#757575').attr('text-anchor', 'end')
      .text('Total')

      canvasItem // Total
      .append('text')
      .attr('x', 155).attr('y', -13)
      .attr('font-size', 9).attr('fill', '#757575').attr('text-anchor', 'middle')
      .text('Actual')

      canvasItem // Total
      .append('text')
      .attr('x', 212).attr('y', -13)
      .attr('font-size', 9).attr('fill', '#757575').attr('text-anchor', 'start')
      .text('Remain')

      let y = 0
      this.items[disc.code].forEach(d=> {

        if(blk[`${d.code}_TOT`] == 0) return

        let pro = blk[`${d.code}_PRO`]
        let proLen = (110/100) * pro
        canvasItem
        .append('text')
        .attr('x', 10).attr('y', y)
        .attr('font-size', 10).attr('fill', '#333')
        .text(d.name)

        canvasItem // Total
        .append('text')
        .attr('x', 97).attr('y', y)
        .attr('font-size', 10).attr('fill', '#333').attr('text-anchor', 'end')
        .text(blk[`${d.code}_TOT`])
        // .call(this.event_Link, disc, {...d, type: 'TOT'}, blk)

        canvasItem 
        .append('rect')
        .attr('x', 100).attr('y', y-9).attr('rx', 2)
        .attr('width', 110).attr('height', 11)
        .attr('fill', '#F4F5F5').attr('opacity', 1)

        canvasItem
        .append('rect')
        .attr('x', 100).attr('y', y-9).attr('rx', 2)
        .attr('width', proLen).attr('height', 11)
        .attr('fill', pro==100 ? '#8BC248' : '#FEED57').attr('opacity', .5)

        canvasItem // Actual
        .append('text')
        .attr('x', pro<70 ? 100+proLen+1 : 100+proLen-1).attr('y', y)
        .attr('font-size', 10).attr('fill', '#000')
        .attr('text-anchor', pro<70 ? 'start' : 'end')
        .text(blk[`${d.code}_ACT`])
        // .call(this.event_Link, disc, {...d, type: 'ACT'}, blk)

        canvasItem // Remain
        .append('text')
        .attr('x', 212).attr('y', y)
        .attr('font-size', 10).attr('fill', '#333')
        .text(blk[`${d.code}_TOT`] - blk[`${d.code}_ACT`])
        // .call(this.event_Link, disc, {...d, type: 'REM'}, blk)

        y += this.items.lineheight
      })
    }
  }
}